<template>
  <!-- 盒子管理-保低配置-常规配置 -->
  <div v-if="$route.query.pv" class="case_guaranteed_config-box">
    <!-- header头部 -->
    <header></header>
    <!-- body内容 -->
    <div class="body-box">
      <h1>保底设置：</h1>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-right: 100px">
          <el-switch
            v-model="formData.enable"
            :active-value="1"
            :inactive-value="0"
            active-text="保底打开"
            inactive-text="保底关闭"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="利润系数">
          <el-input
            v-model="formData.profit"
            placeholder="请输入数值"
          ></el-input>
        </el-form-item>
        <el-form-item label="启动保底金额开箱金额">
          <el-input
            v-model="formData.start_amount"
            placeholder="请输入金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="统计天数">
          <el-input
            v-model="formData.time_range"
            placeholder="请输入天数"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>

      <el-divider></el-divider>
      <h1>保底概率：</h1>
      <p
        class="bapdi-box"
        style="line-height: 50px"
        v-for="(item, index) in formDataProbability"
        :key="index"
      >
        <span style="margin: 0px 10px">L{{ index + 1 }}保底开启金额：</span>
        <el-input
          v-model="item.user_lose_amount"
          placeholder="请输入金额"
          style="width: 100px"
        ></el-input>
        <span style="margin: 0px 10px">次数：</span>
        <el-input
          v-model="item.num"
          placeholder="请输入次数"
          style="width: 100px"
        ></el-input>
        <span style="margin: 0px 10px">概率类型：</span>
        <el-select
          v-model="item.hit_level"
          placeholder="请选择概率"
          style="width: 120px"
        >
          <el-option label="L1" value="l_one"></el-option>
          <el-option label="L2" value="l_two"></el-option>
          <el-option label="L3" value="l_three"></el-option>
          <el-option label="L4" value="l_four"></el-option>
          <el-option label="L5" value="l_five"></el-option>
        </el-select>
        <span style="margin: 0px 10px">回血比例</span>
        <el-input
          v-model="item.return_ratio"
          placeholder="请输入数值"
          style="width: 100px"
        ></el-input>
        <span style="margin: 0px 10px">保底比例</span>
        <el-input
          v-model="item.return_max_ratio"
          placeholder="请输入数值"
          style="width: 100px"
        ></el-input>
      </p>
      <el-button type="primary" @click="submit1()">保存</el-button>

      <el-divider></el-divider>
      <h1>新用户：</h1>
      <el-form style="width: 300px">
        <el-form-item label="新用户充值低于">
          <el-input
            v-model="formDataNewUser.new_user.recharge"
            placeholder="请输入金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="新用户开箱流水低于">
          <el-input
            v-model="formDataNewUser.new_user.unpack"
            placeholder="请输入金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="新用户注册总时长低于">
          <el-input
            v-model="formDataNewUser.new_user.reg_time"
            placeholder="请输入天数"
          ></el-input>
        </el-form-item>
        <el-form-item label="不活跃用户离站时长">
          <el-input
            v-model="formDataNewUser.dead_user"
            placeholder="请输入天数"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit2">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  data() {
    return {
      loading: false,//加载动画
      query: {
        page: 1
      },
      formData: {
        switch_status: 0,//打开或关闭 0是关闭 1是打开
        profit: '',//利润系数
        start_amount: '',//启动保底金额开箱金额
        time_range: '',//统计天数
      },
      formDataNewUser: {
        dead_user: '',
        new_user: {
          recharge: '',
          reg_time: '',
          unpack: '',
        }
      },
      formDataProbability: [
        {
          level: 'l_one',
          user_lose_amount: '',
          num: '',
          hit_level: '',
          return_ratio: '',
          return_max_ratio: '',
        },
        {
          level: 'l_two',
          user_lose_amount: '',
          num: '',
          hit_level: '',
          return_ratio: '',
          return_max_ratio: '',
        },
        {
          level: 'l_three',
          user_lose_amount: '',
          num: '',
          hit_level: '',
          return_ratio: '',
          return_max_ratio: '',
        },
        {
          level: 'l_four',
          user_lose_amount: '',
          num: '',
          hit_level: '',
          return_ratio: '',
          return_max_ratio: '',
        },
        {
          level: 'l_five',
          user_lose_amount: '',
          num: '',
          hit_level: '',
          return_ratio: '',
          return_max_ratio: '',
        },
      ],
      dataList: [1, 2, 3, 4, 5], //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
    this.getData1()
    this.getData2()
  },
  methods: {
    getData() {
      //获取保底设置
      let params = { key: 'bottom_probability' }
      getApiData('system_config_enable', params).then(res => {
        if (res) {
          this.formData = res
        }
      }).finally(() => {
      })
    },
    submit() {
      //保存保底设置
      let params = {
        key: 'bottom_probability',
        val: this.formData
      }
      patchApiData('system_config_enable', params).then(res => {
        this.$message.success("保存成功！")
        this.getData()//刷新
      })
    },
    getData1() {
      getApiData('bottom_pro').then(res => {
        if (res) {
          if (res && res.length) {
            this.formDataProbability = res
          }
        }
      }).finally(() => {
      })
    },
    submit1() {
      let params = { data: this.formDataProbability }
      patchApiData('bottom_pro', params).then(res => {
        this.$message.success("保存成功！")
        this.getData1()//刷新
      }).finally(() => {
      })
    },
    getData2() {
      //获取新用户配置
      let params = { key: 'bottom_pro_user_configs' }
      getApiData('system_config_enable', params).then(res => {
        if (res) {
          this.formDataNewUser = res
        }
      }).finally(() => {
      })
    },
    submit2() {
      //保存新用户配置
      let params = {
        key: 'bottom_pro_user_configs',
        val: this.formDataNewUser
      }
      patchApiData('system_config_enable', params).then(res => {
        this.$message.success("保存成功！")
        this.getData2()//刷新
      })
    },
  }

}
</script>
<style lang="less" scoped>
.case_guaranteed_config-box {
  header {
  }

  .body-box {
    padding-left: 20px;
    // width: 800px;
  }
}
</style>